import React from 'react';
import { usePWAInstallPrompt } from '../../hooks/usePWAInstallPrompt';

/**
 * Floating PWA install dialog. Logic in usePWAInstallPrompt (F20).
 */
const PWAInstallPrompt = ({ analyticsEnabled = false }) => {
  const { showPrompt, isInstalled, promptRef, handleInstallClick, handleDismiss } = usePWAInstallPrompt({
    analyticsEnabled,
  });

  if (isInstalled) return null;
  if (!showPrompt) return null;

  return (
    <div
      ref={promptRef}
      role="dialog"
      aria-modal="true"
      aria-labelledby="pwa-install-title"
      aria-describedby="pwa-install-benefits"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 max-w-md mx-auto animate-slide-up"
    >
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div className="bg-gradient-to-r from-green-600 to-blue-600 p-4 flex items-center gap-3">
          <img
            src="/Logo.jpg"
            alt="Mosqify Logo"
            className="w-12 h-12 rounded-lg object-contain bg-white p-1"
          />
          <div className="flex-1">
            <h3 id="pwa-install-title" className="text-white font-bold text-lg">
              Install Mosqify
            </h3>
            <p className="text-white/90 text-sm">Akses lebih cepat dan mudah</p>
          </div>
        </div>

        <div className="p-4">
          <p id="pwa-install-benefits" className="text-gray-700 dark:text-gray-200 text-sm mb-4">
            Install aplikasi Mosqify untuk akses lebih cepat, notifikasi waktu salat, dan pengalaman yang lebih baik.
          </p>

          <div className="space-y-2 mb-4">
            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
              <svg className="w-5 h-5 text-green-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span>Akses lebih cepat</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
              <svg className="w-5 h-5 text-green-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span>Notifikasi waktu salat</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
              <svg className="w-5 h-5 text-green-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span>Bekerja offline</span>
            </div>
          </div>

          <div className="flex gap-2">
            <button
              type="button"
              onClick={handleInstallClick}
              className="flex-1 bg-gradient-to-r from-green-600 to-blue-600 text-white py-3 px-4 rounded-lg font-semibold hover:shadow-lg transition-all active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-green-600"
            >
              Install Sekarang
            </button>
            <button
              type="button"
              onClick={handleDismiss}
              className="px-4 py-3 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white transition-colors"
              aria-label="Tutup"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slide-up { animation: slide-up 0.3s ease-out; }
      `}</style>
    </div>
  );
};

export default PWAInstallPrompt;
